"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    _AddonsInvoice = _interopRequireDefault(require("./AddonsInvoice")),
    _PaymentOptions = _interopRequireDefault(require("./PaymentOptions"));

require("../styles/_addons-payment.scss");

function AddonsPayment(_ref) {
  var videoOutputs = _ref.videoOutputs,
      addonsSelector = _ref.addonsSelector,
      onModifyAddons = _ref.onModifyAddons,
      videoName = _ref.videoName,
      excludeAdditionalOutputCost = _ref.excludeAdditionalOutputCost,
      updatePurchaseOrderId = _ref.updatePurchaseOrderId,
      totalCost = _ref.totalCost,
      showCreditInfo = _ref.showCreditInfo,
      orgCreditInfo = _ref.orgCreditInfo,
      teamCreditInfo = _ref.teamCreditInfo,
      getCurrencySymbol = _ref.getCurrencySymbol,
      isSaveDisabled = _ref.isSaveDisabled,
      onSelectTeam = _ref.onSelectTeam;
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("div", {
    className: "addons-payment__title"
  }, _react["default"].createElement("div", {
    className: "addons-payment__title__primary"
  }, _react["default"].createElement("span", null, "Confirm Payment"))), _react["default"].createElement("div", {
    className: "addons-payment__body"
  }, _react["default"].createElement("div", {
    className: "addons-payment__body__addons"
  }, _react["default"].createElement(_AddonsInvoice["default"], {
    videoOutputs: videoOutputs,
    addonsSelector: addonsSelector,
    onModifyAddons: onModifyAddons,
    videoName: videoName,
    excludeAdditionalOutputCost: excludeAdditionalOutputCost,
    totalCost: totalCost
  })), _react["default"].createElement("div", {
    className: "addons-payment__body__payments"
  }, _react["default"].createElement(_PaymentOptions["default"], {
    updatePurchaseOrderId: updatePurchaseOrderId,
    showCreditInfo: showCreditInfo,
    orgCreditInfo: orgCreditInfo,
    teamCreditInfo: teamCreditInfo,
    totalCost: totalCost,
    getCurrencySymbol: getCurrencySymbol,
    isSaveDisabled: isSaveDisabled,
    onSelectTeam: onSelectTeam
  }))));
}

var _default = AddonsPayment;
exports["default"] = _default;